'use strict';

export function init() {
  const globalAlerts = document.querySelector('.global-alerts');
  const globalHeader = document.querySelector('.js-global-header');
  const globalHeaderSticky = document.querySelector('.global-header');

  if (!globalHeader) return;

  const handleScroll = () => {
    if (!globalHeaderSticky) return;

    const currentHeight = globalHeader.offsetHeight;
    const y = window.scrollY;

    if (y >= currentHeight - 50) {
      globalHeaderSticky.classList.add('header-scroll');
    } else {
      globalHeaderSticky.classList.remove('header-scroll');
    }
  };

  const setGroupHeight = () => {
    const alertsHeight = globalAlerts ? globalAlerts.offsetHeight : 0;
    const headerHeight = globalHeaderSticky ? globalHeaderSticky.offsetHeight : 0;
    
    document.documentElement.style.setProperty(
      '--global-header-height', `${alertsHeight + headerHeight}px`
    );
    document.documentElement.style.setProperty(
      '--global-alert-height', `${alertsHeight}px`
    );
  };

  // Use a ResizeObserver to detect changes in the size of .global-alerts
  if ('ResizeObserver' in window && globalAlerts) {
    const resizeObserver = new ResizeObserver(() => {
      setGroupHeight();
    });
    resizeObserver.observe(globalAlerts);
  }

  setGroupHeight();
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', setGroupHeight);
}
